export class NotebookExecutionOutput {
    'type';
    'name';
    'text';
    'data';
    'ename';
    'evalue';
    'traceback';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "type",
            "baseName": "type",
            "type": "NotebookExecutionOutputTypeEnum",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "text",
            "baseName": "text",
            "type": "string",
            "format": ""
        },
        {
            "name": "data",
            "baseName": "data",
            "type": "{ [key: string]: any; }",
            "format": ""
        },
        {
            "name": "ename",
            "baseName": "ename",
            "type": "string",
            "format": ""
        },
        {
            "name": "evalue",
            "baseName": "evalue",
            "type": "string",
            "format": ""
        },
        {
            "name": "traceback",
            "baseName": "traceback",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return NotebookExecutionOutput.attributeTypeMap;
    }
    constructor() {
    }
}
export var NotebookExecutionOutputTypeEnum;
(function (NotebookExecutionOutputTypeEnum) {
    NotebookExecutionOutputTypeEnum["NOTEBOOK_OUTPUT_TYPE_STREAM"] = "stream";
    NotebookExecutionOutputTypeEnum["NOTEBOOK_OUTPUT_TYPE_EXECUTE_RESULT"] = "execute_result";
    NotebookExecutionOutputTypeEnum["NOTEBOOK_OUTPUT_TYPE_DISPLAY_DATA"] = "display_data";
    NotebookExecutionOutputTypeEnum["NOTEBOOK_OUTPUT_TYPE_ERROR"] = "error";
})(NotebookExecutionOutputTypeEnum || (NotebookExecutionOutputTypeEnum = {}));
